export default __webpack_public_path__ + "static/media/icn-valid.67a22e04.svg";